import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./AwardModal.css";

function AwardModal({
  show,
  handleClose,
  mode = "edit",
  award,
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (mode === "edit" && award) {
      setTitle(award.title || "");
      setDescription(award.description || "");
    } else {
      setTitle("");
      setDescription("");
    }
  }, [award, mode]);

  const handleSave = () => {
    console.log({
      title,
      description,
    });

    handleClose();
  };

  const handleDelete = () => {
    console.log("Delete Award");
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal award-modal"
    >
      <Modal.Header className="award-modal__header">
        <Modal.Title>
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          {mode === "add" ? "Add award" : "Edit award"}
        </Modal.Title>

        <button
          className="btn-close"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      <Modal.Body className="award-modal__body">

        <Form.Group className="mb-4">
          <Form.Label className="award-modal__label">
            Title <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            className="award-modal__input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label className="award-modal__label">
            Description
          </Form.Label>

          <Form.Control
            as="textarea"
            rows={5}
            maxLength={1000}
            className="award-modal__textarea"
            placeholder="Enter description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="award-modal__count">
            Max. {description.length}/1000 character
          </div>
        </Form.Group>

      </Modal.Body>

      <Modal.Footer className="award-modal__footer">

        {mode === "edit" ? (
          <Button
            variant="link"
            className="award-modal__delete"
            onClick={handleDelete}
          >
            Delete Award
          </Button>
        ) : (
          <div />
        )}

        <Button
          className="award-modal__save"
          onClick={handleSave}
        >
          Save
        </Button>

      </Modal.Footer>
    </Modal>
  );
}

export default AwardModal;